export default __webpack_public_path__ + "static/media/lightswitch.77a912d8.mp3";